export const generateUrlSearchParametersFromRecord = (
  basePath: string,
  data: Record<string, string | number | undefined> | null | undefined,
  fallback: string,
): string => {
  if (!data) {
    return fallback;
  }
  const params = Object.entries(data);
  const searchFilters = params
    .filter((param) => param[1]?.toString())
    .map(([key, value]) => `${key}=${encodeURI(value!.toString())}`);
  return `${basePath}?${searchFilters.join('&')}`;
};

export const createSingleSearchParameter = (paramName: string, data: Record<string, string | number | undefined>) => {
  return `?${paramName}=${encodeURIComponent(generateUrlSearchParametersFromRecord('', data, ''))}`;
};
